// Status of a manual off-market/supplemental listing. `id` is the stored CF status code (PEND/SOLD/
// UNKN) so it maps directly to the API's `status` field and the form's radio values. Modeled on
// src/type/lead-status.ts.
class Type {

	public static PENDING = new Type("PEND", "Pending");
	public static SOLD = new Type("SOLD", "Sold");
	public static UNKNOWN = new Type("UNKN", "Unknown");

	private constructor(
		public readonly id: "PEND" | "SOLD" | "UNKN",
		public readonly label: string,
	) {
	}

	public get pending() {
		return this === Type.PENDING;
	}

	public get sold() {
		return this === Type.SOLD;
	}

	public get unknown() {
		return this === Type.UNKNOWN;
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id: string) {
		return this.values().find(value => value.id === id);
	}

}

export { Type as OffMarketStatus };
